import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventDisplayViewModel, ScheduledEventViewModel } from 'src/app/_models/generatedModels';
import { EventService } from 'src/app/_services/generatedServices';
import * as moment from 'moment';
import 'moment-timezone';

@Component({
  selector: 'bxl-event-details-flyout',
  templateUrl: 'event-details-flyout.component.html',
})
export class EventDetailsFlyoutComponent implements OnInit {
  initialized = false;
  @Input() event: ScheduledEventViewModel;
  evt: EventDisplayViewModel;
  timezone: string;
  constructor(private evtService: EventService, private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    let timeZone = moment.tz.guess();
    console.log(timeZone);
    let timeZoneOffset = new Date(this.event.startTime).getTimezoneOffset();
    this.timezone = moment.tz(timeZone).format('z');

    this.evtService.getSpecificEvent(this.event.id.toString()).subscribe((evt) => {
      this.evt = evt;
      this.initialized = true;
    });
  }

  onCancel() {
    this.activeModal.dismiss();
  }
}
